var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
export var mapChannelAccountMode = {
    SANDBOX: "sandbox",
    LIVE: "live",
    na: "N/A",
    sandbox: "sandbox",
    live: "live",
};
export var getStatusFromChannel = function (channel) {
    var _a, _b, _c, _d, _e, _f;
    if (((_a = channel === null || channel === void 0 ? void 0 : channel.integration) === null || _a === void 0 ? void 0 : _a.hasOwnProperty("enabled")) &&
        ((_b = channel === null || channel === void 0 ? void 0 : channel.integration) === null || _b === void 0 ? void 0 : _b.enabled) === false) {
        return "disabled";
    }
    else if ((channel === null || channel === void 0 ? void 0 : channel.version) === 1) {
        if (channel === null || channel === void 0 ? void 0 : channel.integration) {
            if (((_c = channel === null || channel === void 0 ? void 0 : channel.integration) === null || _c === void 0 ? void 0 : _c.state) === "finalizing") {
                return "draft";
            }
            else if ((channel === null || channel === void 0 ? void 0 : channel.status) === "unregistered") {
                return "unregistered";
            }
            else {
                return mapToCommonStatusIntegration[(_d = channel === null || channel === void 0 ? void 0 : channel.integration) === null || _d === void 0 ? void 0 : _d.state];
            }
        }
        else if ((channel === null || channel === void 0 ? void 0 : channel.status) === "unregistered") {
            return "unregistered";
        }
        else {
            return "draft";
        }
    }
    else {
        if ((channel === null || channel === void 0 ? void 0 : channel.status) === "unregistered") {
            // TODO: Update those statuses
            return "unregistered";
        }
        else if ((channel === null || channel === void 0 ? void 0 : channel.accountMode) !== "" &&
            (channel === null || channel === void 0 ? void 0 : channel.integration) &&
            ((_e = channel === null || channel === void 0 ? void 0 : channel.integration) === null || _e === void 0 ? void 0 : _e.state) !== "registration_failed") {
            return mapChannelAccountMode[channel === null || channel === void 0 ? void 0 : channel.accountMode];
        }
        else if (((_f = channel === null || channel === void 0 ? void 0 : channel.integration) === null || _f === void 0 ? void 0 : _f.state) === "registration_failed") {
            return "rejected";
        }
        else if ((channel === null || channel === void 0 ? void 0 : channel.status) === "ready") {
            return "live";
        }
        else {
            return "draft";
        }
    }
};
export var mapToCommonStatusPartner = {
    created: "neutral",
    active: "success",
    approved: "success",
    pending: "pending",
    pending_billing_terms: "pending",
    initial_onboarding_started: "pending",
    initial_onboarding_billing_terms: "pending",
    initial_onboarding_billing_address: "pending",
    initial_onboarding_payment_method: "pending",
    initial_onboarding_choose_experience: "pending",
    initial_onboarding_integrated_onboarding: "pending",
    initial_onboarding_register_number: "pending",
    initial_onboarding_send_and_receive_messages: "pending",
};
export var mapToCommonStatusWabaAccount = {
    created: "draft",
    unverified: "pending",
    pending_review: "pending",
    pending: "pending",
    approved: "live",
    obo_not_approved: "rejected",
    consents_pending: "pending",
    verification_failed: "rejected",
    error: "rejected",
    bsp_removed: "rejected",
    banned: "rejected",
};
export var mapToLabelStatusFbAccount = {
    unknown: "unknown",
    verified: "verified",
    not_verified: "not verified",
    pending_need_more_info: "pending - need more info",
    rejected: "rejected",
    pending: "pending",
    pending_submission: "pending submission",
    failed: "failed",
    revoked: "revoked",
};
export var mapToCommonStatusFbAccount = {
    unknown: "draft",
    verified: "live",
    not_verified: "draft",
    pending_need_more_info: "pending",
    rejected: "rejected",
    failed: "rejected",
    pending: "pending",
    pending_submission: "pending",
};
export var mapToCommonStatusOnBehalf = {
    submitted: "pending",
    approved: "live",
    rejected: "rejected",
    pending: "pending",
    denied: "rejected",
};
export var mapToCommonStatusWabaChannel = {
    created: "draft",
    unverified: "display name in review",
    missing_consents: "pending",
    consents_signed: "pending",
    certificate_declined: "display name rejected",
    verified: "live",
    ready: "live",
    permission_granted: "live",
    unregistered: "unregistered",
};
export var mapToLabelStatusIntegration = {
    created: "created",
    setting_up: "setting up",
    registration_ready: "registration_ready",
    registration_triggered: "registration triggered",
    ready_for_finalize: "ready for finalize",
    finalizing: "finalizing",
    running: "running",
    cloud_api_creating: "cloud_api_creating",
    waba_incompatible: "waba_incompatible",
    setup_failed: "setup_failed",
    registration_failed: "rejected",
};
export var mapToCommonStatusIntegration = {
    created: "draft",
    setting_up: "draft",
    running: "live",
    registration_ready: "pending",
    registration_triggered: "pending",
    ready_for_finalize: "pending",
    finalizing: "pending",
    pending_review: "pending",
    ready: "live",
    unregistered: "unregistered",
    registration_failed: "rejected",
};
export var mapToLabelStatusWabaAccount = function (status) {
    switch (status) {
        case "obo_not_approved": {
            return "failed commerce policy";
        }
        case "pending_review": {
            return "pending review";
        }
        case "consents_pending": {
            return "consents pending";
        }
        case "verification_failed": {
            return "business verification failed";
        }
        case "ready_for_migration": {
            return "ready for migration";
        }
        case "migration_code_requested": {
            return "migration code requested";
        }
        case "bsp_removed": {
            return "BSP permission removed";
        }
        default: {
            return status;
        }
    }
};
export var mapToLabelDisplayNameStatus = function (status) {
    switch (status) {
        case "unverified": {
            return "display name in review";
        }
        case "certificate_declined": {
            return "display name rejected";
        }
        case "consents_signed": {
            return "consents signed";
        }
        case "consents_pending": {
            return "consents pending";
        }
        case "ready_for_migration": {
            return "ready for migration";
        }
        case "waiting_for_migration_code": {
            return "ready for migration code";
        }
        case "new_name_requested": {
            return "new display name requested";
        }
        case "migration_code_requested": {
            return "migration code requested";
        }
        case "permission_granted": {
            return "live";
        }
        default: {
            return status;
        }
    }
};
export var getColorByStatus = function (status) {
    switch (status) {
        case "success":
        case "done":
        case "live": {
            return "green";
        }
        case "pending": {
            return "yellow";
        }
        case "error":
        case "rejected":
        case "unregistered":
        case "flagged": {
            return "red";
        }
        default: {
            return "grey";
        }
    }
};
export var AVAILABILITY_STATUS_FILTER_OPTIONS = [
    "setting_up",
    "ready",
    "error",
    "cancelled",
    "inactive",
];
export var AVAILABILITY_STATUS_LABELS = {
    setting_up: "Setting up",
    ready: "Ready",
    error: "Error",
    cancelled: "Cancelled",
    inactive: "Inactive",
};
var AVAILABILITY_STATUS_LABELS_REVERSE = Object.fromEntries(Object.entries(AVAILABILITY_STATUS_LABELS).map(function (_a) {
    var _b = __read(_a, 2), apiValue = _b[0], label = _b[1];
    return [
        label.toLowerCase(),
        apiValue,
    ];
}));
export var toAvailabilityStatusApi = function (value) {
    var _a;
    var normalized = value.toLowerCase().trim();
    if (AVAILABILITY_STATUS_LABELS[normalized])
        return normalized;
    return ((_a = AVAILABILITY_STATUS_LABELS_REVERSE[normalized]) !== null && _a !== void 0 ? _a : normalized.replace(/\s+/g, "_"));
};
export var toAvailabilityStatusLabel = function (value) {
    var _a;
    var key = toAvailabilityStatusApi(value);
    return (_a = AVAILABILITY_STATUS_LABELS[key]) !== null && _a !== void 0 ? _a : value;
};
//# sourceMappingURL=data:application/json;base64,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